// extracted by mini-css-extract-plugin
module.exports = {"inputFile":"AvatarImage_inputFile__esDyq"};